import React, { useEffect, useMemo, useState } from "react";
import "./style.scss";
import countBannerBanix from "../../../images/count-banner-banix.png";
import gameBanix from "../../../images/game-banix.png";
import { APP_PRIZE_COINS } from "../../constants";

export const CountdownBanner = () => {
  const [showCountdown, setShowCountdown] = useState(false);
  const [daysLeft, setDaysLeft] = useState(0);
  const [isPremiereDay, setIsPremiereDay] = useState(false);

  useEffect(() => {
    const targetDate = new Date("2024-12-21T19:00:00Z"); // 21 декабря 2024 года, 22:00 по Москве (UTC+3)
    const currentDate = new Date();


    const timeDiff = targetDate - currentDate;

    if (timeDiff === 0) {
      setIsPremiereDay(true);
    } else {
      const daysRemaining = Math.ceil(timeDiff / (1000 * 3600 * 24));
      setShowCountdown(currentDate < targetDate);
      setDaysLeft(daysRemaining);
    }
  }, []);

  function getDayWord(days) {
    if (days === 1) {
      return "день";
    } else if (days > 1 && days < 5) {
      return "дня";
    } else {
      return "дней";
    }
  }

  return (
    <div className="app-countdown-banner">
      <div className="app-countdown-banner--images-container">
        <img
          src={countBannerBanix}
          alt=""
          className="app-countdown-banner--lady-image"
        />
        <img
          src={gameBanix}
          alt=""
          className="app-countdown-banner--banix-image"
        />
      </div>
      <div className="app-countdown-banner--content">
        {isPremiereDay ? (
          <div className="app-countdown-banner--title">Сегодня премьера!</div>
        ) : (
          showCountdown && (
            <div className="app-countdown-banner--title">
              {daysLeft} {getDayWord(daysLeft)} до премьеры!
            </div>
          )
        )}
        <div className="app-countdown-banner--description">
          {isPremiereDay
            ? "Большой марафон на ТВ-3! 🐞 🤩"
            : "Большой марафон на ТВ-3 — уже 21 декабря! 🐞 🤩"}
        </div>
      </div>
    </div>
  );
};
